﻿import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

{
  /*Snackbar Notification that bases its visual appearance on useQuery and its status
 - takes status of the query
 - takes open bool value for triggering the notif
 - takes the onClose trigger 
 */
}

export default function NotificationSnackbar({
  duration,
  status,
  openTrigger,
  onClose,
  successMsg,
  errorMsg,
}) {
  let msg = '';

  if ((duration === undefined) | (duration == null)) duration = 5000;

  switch (status) {
    case 'success':
      msg = successMsg != null ? successMsg : 'Success';
      return (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={duration}
          open={openTrigger}
          onClose={onClose}
        >
          <div
            style={{
              background: 'green',
              padding: '0.5em',
              borderRadius: '1em',
              color: 'white',
            }}
          >
            <div>
              <div className="row" style={{ display: 'inline-flex' }}>
                <CheckCircleOutlineIcon />
                {msg}
              </div>
            </div>
          </div>
        </Snackbar>
      );
    case 'error':
      msg = errorMsg != null ? errorMsg : 'Error. Please try again.';
      return (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={duration == undefined ? 5000 : duration}
          open={openTrigger}
          onClose={onClose}
        >
          <div
            style={{
              background: 'red',
              padding: '0.5em',
              borderRadius: '1em',
              color: 'white',
            }}
          >
            <div>
              <div className="row" style={{ display: 'inline-flex' }}>
                <ErrorOutlineIcon />
                {msg}
              </div>
            </div>
          </div>
        </Snackbar>
      );
    case '':
    case 'loading':
    case 'idle':
      return null;
    default:
      return null;
  }
}
